// Generated from the English keys in lib/i18n.ts (same {slot} placeholders). Russian renders only in partner views.
export const RU: Record<string, string> = {
  "Guess the Goal": "Угадай гол",
  "Name the iconic goal — real rewards, server-scored": "Угадай легендарный гол — получай награды",
  "Solved {n}/{total}": "Решено: {n}/{total}",
  "+{points} points": "Очки: +{points}",
  "Move {n}/{total}": "Ход {n}/{total}",
  "Which goal is this?": "Что это за гол?",
  "Bonus question": "Бонусный вопрос",
  "Next goal": "Следующий гол",
  "Guess the Goal is warming up — check back soon": "«Угадай гол» готовится к запуску — загляни позже",
  "A legendary goal replays on the coaching board. The earlier you name it, the more you earn — first solve of each goal pays coins and XP.": "Легендарный гол на тактической доске. Чем быстрее угадаешь, тем больше получишь — монеты и XP дают за первое решение каждого гола.",
  "(daily cap)": "(дневной лимит)",
  "Already solved before — no repeat rewards": "Уже решено — награда не начисляется",
  "Something went wrong — try again": "Что-то пошло не так — попробуй еще раз",
  "Watch the real goal": "Смотреть реальный гол",
  "Back to the board": "Назад к доске",
  "Board": "Доска",
  "Video": "Видео",
  "Replay board": "Повтор на доске",
  "Couldn't load your game": "Не удалось загрузить игру",
  "Prototype — virtual points only, no real money or rewards": "Прототип — только виртуальные очки, без реальных выплат",
  "Points": "Очки",
  "Play again": "Играть снова",
  "Try again": "Попробовать снова",
  "Next": "Далее",
  "Back": "Назад",
  "Opponent": "Соперник",
  "Accumulator": "Экспресс",
  "Five legs. One stake. All must land.": "Пять событий. Одна ставка. Все должны зайти.",
  "Pick 5 legs · {n}/5": "Выбери 5 событий · {n}/5",
  "Continue · {odds}x": "Продолжить · {odds}x",
  "Potential return": "Возможный выигрыш",
  "Your stake": "Твоя ставка",
  "Place bet · {stake}": "Сделать ставку · {stake}",
  "Back to legs": "К событиям",
  "Return so far": "Текущий возврат",
  "4 of 5 landed!": "4 из 5 зашли!",
  "Take the money or go for it?": "Заберешь деньги или рискнешь?",
  "One leg left. Cash out now, or risk it for the full {amount}.": "Осталось одно событие. Забирай сейчас или рискни ради {amount}.",
  "Cash out": "Забрать",
  "Final leg": "Финал",
  "Bet won!": "Ставка зашла!",
  "Busted on leg {n}": "Проигрыш на этапе {n}",
  "Lost your {stake} stake — one leg let it down.": "Ставка {stake} проиграна — одно событие подвело.",
  "New accumulator": "Новый экспресс",
  "if it lands:": "если зайдет:",
  "{leg}/{total} legs": "Событий: {leg}/{total}",
  "Leg {n}": "Этап {n}",
  "Answer right to boost your odds": "Ответь верно, чтобы повысить кэф",
  "Bet Slip · Treble": "Купон · Требл",
  "3 selections": "3 исхода",
  "boosted": "с бустом",
  "Total odds": "Общий кэф",
  "Boost leg {n} · {club}": "Буст этапа {n} · {club}",
  "Boosted {a} → {b}": "Буст {a} → {b}",
  "Stake {stake} · potential return": "Ставка {stake} · возврат",
  "Slip landed!": "Купон зашел!",
  "Not this time": "Не в этот раз",
  "The boosted {odds}x didn't come in.": "Буст {odds}x не сыграл.",
  "New slip": "Новый купон",
  "Bank it or climb — one wrong answer wipes it all": "Забирай или рискуй — одна ошибка обнулит всё",
  "Stake": "Ставка",
  "Wiped": "Сгорело",
  "Banked": "В банке",
  "Pot at risk": "Риск",
  "{mult}x on {stake}": "{mult}x от {stake}",
  "Stake {stake} & climb": "Ставь {stake} и лезь вверх",
  "Bank {pot} now, or risk it for {next}?": "Забрать {pot} сейчас или рискнуть ради {next}?",
  "Bank {pot}": "Забрать {pot}",
  "Climb to {mult}x": "К {mult}x",
  "Wiped!": "Сгорело!",
  "Wrong answer at {mult}x — the whole pot is gone.": "Ошибка на {mult}x — весь банк потерян.",
  "Banked {amount}": "Забрано {amount}",
  "😱 It would have hit 32x!": "😱 Могло дойти до 32x!",
  "Smart! You'd have busted at {mult}x.": "Умно! Ты бы проиграл на {mult}x.",
  "It would've climbed to {a}x then busted at {b}x.": "Дошло бы до {a}x, но сгорело на {b}x.",
  "Go again": "Ещё раз",
  "One hard question. Winner takes the pot.": "Один сложный вопрос. Победитель забирает банк.",
  "Today's pot": "Сегодняшний банк",
  "climbing with every miss…": "растёт с каждым промахом…",
  "failed today": "сегодня не вышло",
  "next question": "следующий вопрос",
  "Hard · one attempt": "Сложно · одна попытка",
  "Rolled over": "Перенесено",
  "Not this time — your entry fed the pot. It now sits at {pot}. Come back for the next question in {time}.": "Не в этот раз — твой взнос пополнил банк. Сейчас там {pot}. Возвращайся за новым вопросом через {time}.",
  "Replay": "Переиграть",
  "Jackpot won!": "Джекпот разыгран!",
  "The pot resets for tomorrow's question.": "Банк обновится к завтрашнему вопросу.",
  "Live": "Live",
  "Half-Time Quiz": "Квиз в перерыве",
  "Question {n} / {total}": "Вопрос {n} / {total}",
  "Get {n}+ for a free bet · {c} right": "Нужно {n}+ для фрибета · верно: {c}",
  "Free bet won!": "Фрибет твой!",
  "{c}/{total} — so close": "{c}/{total} — почти получилось",
  "You earned a virtual second-half free bet (demo — no real rewards).": "Ты заработал виртуальный фрибет на второй тайм (демо — без реальных наград).",
  "Get {n}+ right before kickoff to earn a free bet.": "Ответь верно на {n}+ до начала матча, чтобы получить фрибет.",
  "Markets": "Маркеты",
  "Odds are illustrative · prototype": "Коэффициенты для примера · прототип",
  "Prototype — virtual only": "Прототип — только виртуально",
  "Odds Board": "Доска кэфов",
  "Every answer is a market — back your call": "Каждый ответ — это маркет: ставь на свой выбор",
  "Market {n}": "Маркет {n}",
  "{pct}% implied": "Вероятность: {pct}%",
  "returns": "выплата",
  "Pick an answer to back": "Выбери вариант для ставки",
  "Place {stake} on {answer}": "Ставка {stake} на {answer}",
  "Won {amount}!": "Выигрыш: {amount}!",
  "Lost {amount}": "Проигрыш: {amount}",
  "Big-odds call!": "Риск оправдался!",
  "Right answer:": "Верный ответ:",
  "Next market": "Следующий маркет",
  "Pass Chain": "Pass Chain",
  "Link the two players through shared clubs": "Свяжи двух игроков через общие клубы",
  "Fewer links score higher": "Меньше связей — больше очков",
  "Par —": "Пар —",
  "Par {par} links": "Пар: {par} связ.",
  "Who links to {name}?": "Кто связан с {name}?",
  "Add": "Добавить",
  "Already in the chain": "Уже в цепочке",
  "Unknown player — try another": "Неизвестный игрок — попробуй другого",
  "{a} never played with {b}": "{a} никогда не играл с {b}",
  "Reset": "Сброс",
  "Linked!": "Связано!",
  "{n} links": "Связей: {n}",
  "Par — perfect!": "Пар — идеально!",
  "par {n}": "пар: {n}",
  "Next chain": "След. цепочка",
  "START": "СТАРТ",
  "TARGET": "ЦЕЛЬ",
  "Penalty Shootout": "Серия пенальти",
  "Round {n} / {total}": "Раунд {n} / {total}",
  "You · AI": "Ты · ИИ",
  "Answer to earn your shot": "Ответь, чтобы пробить",
  "Opponent is stepping up…": "Соперник готовится...",
  "AI is on target — get ready to dive!": "ИИ бьет — готовься к прыжку!",
  "AI answering…": "ИИ отвечает...",
  "Pick your corner — beat the keeper": "Выбери угол и переиграй вратаря",
  "You're in goal — pick your dive!": "Ты в воротах — прыгай!",
  "GOAL!": "ГОЛ!",
  "MISSED": "МИМО",
  "AI SCORES": "ИИ ЗАБИВАЕТ",
  "SAVED!": "СЕЙВ!",
  "Opponent's turn": "Ход соперника",
  "See result": "Результат",
  "Next round": "След. раунд",
  "You win!": "Победа!",
  "Draw": "Ничья",
  "You lose": "Поражение",
  "Free Kicks": "Штрафные",
  "Know football. Read the goal. Take the shot.": "Знай футбол. Читай игру. Бей точно.",
  "Balance": "Баланс",
  "Pot": "Банк",
  "Your pot": "Твой банк",
  "Stake {n} & attack": "Ставь {n} и атакуй",
  "Min {n}": "Мин. {n}",
  "Top up (demo)": "Пополнить (демо)",
  "Answer to scout the keeper": "Ответь, чтобы проверить вратаря",
  "{n}s": "{n} сек.",
  "Time's up — blind shot": "Время вышло — удар вслепую",
  "Wrong — the correct answer stays. Blind shot.": "Неверно — правильный ответ остается. Удар вслепую.",
  "Answer to scout the keeper — knowledge sharpens the shot, the risk stays.": "Ответь, чтобы проверить вратаря — знания улучшат удар, риск остается.",
  "Attack {n}": "Атака {n}",
  "SCOUT REPORT ✓ — one save zone revealed": "ОТЧЕТ СКАУТА ✓ — одна зона сейва открыта",
  "No scout — blind shot pays more": "Без скаута — удар вслепую дает больше",
  "Pick your shot zone": "Выбери зону удара",
  "4 GOAL · 2 SAVE": "4 ГОЛА · 2 СЕЙВА",
  "4 GOAL · 1 SAVE": "4 ГОЛА · 1 СЕЙВ",
  "TAKE {amount}": "ЗАБРАТЬ {amount}",
  "NEXT ATTACK": "СЛЕД. АТАКА",
  "Next attack risks the whole pot — the keeper resets.": "Следующая атака рискует всем банком — вратарь сбрасывается.",
  "The keeper read it — pot lost.": "Вратарь прочитал удар — банк потерян.",
  "Cashed out {amount}!": "Забрал {amount}!",
  "Loading…": "Загрузка…",
  "Could not load balance — tap to retry": "Ошибка баланса — нажми, чтобы повторить",
  "New round": "Новый раунд",
  "Live wins": "Победы в эфире",
  "Longest runs today": "Лучшие серии за сегодня",
  "{n} playing now": "Играют: {n}",
  "{pct}% answered correctly": "Верных ответов: {pct}%",
  "{pct}% scored": "Забито: {pct}%",
  "{pct}% cashed out": "Забрали выигрыш: {pct}%",
  "{n} going NEXT ATTACK": "СЛЕДУЮЩАЯ АТАКА: {n}",
  "You": "Ты",
  "just now": "только что",
  "{n}m ago": "{n} мин. назад",
  "Squad Collection": "Коллекция состава",
  "Answer to pull cards. Build your XI.": "Отвечай и тяни карты. Собери свою команду.",
  "Squad": "Состав",
  "Answer to earn a pack": "Ответь, чтобы получить пак",
  "Tap to open": "Нажми, чтобы открыть",
  "Add to squad": "В состав",
  "Squad complete!": "Состав собран!",
  "Reward: +2,000 🪙": "Награда: +2,000 🪙",
  "Start a new squad": "Начать новый состав",
  "Bronze": "Бронза",
  "Silver": "Серебро",
  "Gold": "Золото",
  "Special": "Особая",
  "Easy": "Легко",
  "Hard": "Сложно",
  "Expert": "Эксперт",
  "Name a player who fits every reel": "Назови игрока под все барабаны",
  "{n} reels": "Барабанов: {n}",
  "Spin": "Крутить",
  "Spinning…": "Вращение…",
  "Name a player…": "Назови игрока…",
  "Go": "ОК",
  "Hold a reel, respin the rest": "Удерживай барабан, перекрути остальные",
  "Respin −{n}": "Перекрутить −{n}",
  "Last 3 spins": "Последние 3",
  "Missed": "Мимо",
  "Correct!": "Верно!",
  "Only {pct}% named this": "Лишь {pct}% назвали его",
  "rarity": "редкость",
  "Time's up": "Время вышло",
  "You could've said:": "Можно было назвать:",
  "No valid player for that combo!": "Для этого комбо нет игроков!",
  "Spin again": "Ещё раз",
  "Hold reel": "Удержать",
  "Release reel": "Отпустить",
  "Club": "Клуб",
  "Position": "ПОЗ",
  "Nation": "Страна",
  "Era": "Эпоха",
  "Trophy": "Трофей",
  "easy": "легко",
  "medium": "средне",
  "hard": "сложно",
  "Answer to earn spins — the wheel pays out": "Отвечай и получай спины — колесо дает призы",
  "Coins": "монеты",
  "Question {n}": "Вопрос {n}",
  "+1 spin earned": "+1 спин получен",
  "No spin — try the next one": "Без спина — пробуй следующий",
  "{n} spins available": "Доступно спинов: {n}",
  "JACKPOT!": "ДЖЕКПОТ!",
  "Spin the wheel": "Крути колесо",
  "Answer to earn a spin": "Ответь, чтобы получить спин",
  "Full Time Result": "Итог матча",
  "Next Goal": "Следующий гол",
  "Total Goals Over/Under 3.5": "Тотал голов больше/меньше 3.5",
  "Both Teams to Score — 2nd Half": "Обе забьют — 2-й тайм",
  "No more goals": "Голов больше не будет",
  "Over 3.5": "Больше 3.5",
  "Under 3.5": "Меньше 3.5",
  "Yes": "Да",
  "No": "Нет",
  "Champions League · Group Stage": "Лига чемпионов · Групповой этап",
  "Real Madrid to win": "Победа Реал Мадрид",
  "Man City to win": "Победа Ман Сити",
  "Bayern to win": "Победа Баварии",
  "Goalkeeper": "Вратарь",
  "Zone": "Зона",
  "Closest Wins": "Кто ближе",
  "Defender": "Защитник",
  "Midfielder": "Полузащитник",
  "Forward": "Нападающий",
  "World Cup": "Чемпионат мира",
  "League": "Лига",
  "Champions League": "Лига чемпионов",
  "League Title": "Титул лиги",
  "Football Tic Tac Toe": "Футбольные крестики-нолики",
  "Claim cells with players — three in a row wins": "Занимай клетки игроками — три в ряд для победы",
  "You · Opponent": "Ты · Соперник",
  "Pick a cell and name a player who played for that club AND that nation. Your opponent answers back — line up three to win.": "Выбери клетку и назови игрока, выступавшего за этот клуб И эту сборную. Соперник ответит тем же — собери три в ряд.",
  "Start match": "Начать матч",
  "Your turn — pick a cell": "Твой ход — выбирай клетку",
  "Not a match — turn passes": "Не подходит — переход хода",
  "Time's up — turn passes": "Время вышло — переход хода",
  "Pass": "Пас",
  "Opponent blanked — your turn!": "Соперник не ответил — твой ход!",
  "Opponent is thinking…": "Соперник думает…",
  "Opponent wins": "Соперник победил",
  "Three in a row!": "Три в ряд!",
  "Board full — {a} cells vs {b}": "Поле заполнено — {a} кл. против {b}",
  "New grid": "Новая сетка",
  "{pct}%": "{pct}%",
  "Brazil": "Бразилия",
  "France": "Франция",
  "Argentina": "Аргентина",
  "Spain": "Испания",
  "Netherlands": "Нидерланды",
  "Portugal": "Португалия",
  "Survivor": "Survivor",
  "One wrong answer and you are out — how long can you last?": "Одна ошибка — и ты вылетаешь. Как долго ты продержишься?",
  "Streak": "Серия",
  "Sudden death": "На вылет",
  "Questions get harder as you go. {n} virtual players start with you — outlast them all.": "Вопросы становятся сложнее. С тобой стартуют виртуальные игроки (кол-во: {n}) — продержись дольше всех.",
  "Best streak: {n}": "Лучшая серия: {n}",
  "Enter the arena": "На арену",
  "Still standing": "В игре",
  "Eliminated": "Выбыл",
  "Streak of {n}": "Серия: {n}",
  "You outlasted {pct}% of the field — {left} were still standing.": "Ты обошел {pct}% участников — осталось в игре: {left}.",
  "New best!": "Новый рекорд!",
  "Run it back": "Еще раз",
  "Last one standing!": "Последний герой!",
  "You cleared every question in the bank — a perfect {n}-answer run.": "Ты ответил на все вопросы в базе — идеальная серия, ответов: {n}.",
  "Hi-Lo Ride": "Hi-Lo Ride",
  "Call the higher stat — odds priced by how many get it right": "Выбери больший показатель — кэф зависит от популярности ответа",
  "Chain higher-or-lower calls. Every correct call multiplies your stake — hard matchups pay more. Cash out before you miss.": "Угадывай «больше или меньше». Каждый верный ответ множит ставку — сложные пары дают больше. Забирай выигрыш, пока не ошибся.",
  "Stake {stake} & ride": "Ставка {stake} и погнали",
  "Step {n} · odds": "Шаг {n} · кэф",
  "{pct}% of players call this one right": "{pct}% игроков выбирают этот вариант",
  "Which is higher?": "Где больше?",
  "Higher": "Больше",
  "Pot is {pot}. Next matchup pays {odds}x → {next}.": "Банк: {pot}. Следующий ход даст {odds}x → {next}.",
  "Cash out {pot}": "Забрать {pot}",
  "Ride on": "Продолжить",
  "Wrong call": "Неверно",
  "The ride ends — your {stake} stake is gone.": "Игра окончена — ставка {stake} сгорела.",
  "New ride": "Новая игра",
  "Cashed {amount}!": "Забрал {amount}!",
  "{n} correct calls — {mult}x your stake.": "Верных ответов: {n} — выигрыш {mult}x.",
  "Trivia Mines": "Trivia Mines",
  "Dribble past hidden defenders — scout them with your knowledge": "Обыгрывай скрытых защитников, используя свои знания",
  "{d} defenders hide in {n} tiles. Every clean dribble grows the pot — hit a defender and lose it all. Answer questions to scout defenders out.": "Защитников: {d}, плиток: {n}. Каждый дриблинг увеличивает банк, но столкновение с защитником обнуляет всё. Отвечай на вопросы, чтобы найти их.",
  "Stake {stake} & dribble": "Ставка {stake} и дриблинг",
  "Tackled": "Отобрали мяч",
  "Now · next tile": "Сейчас · след. плитка",
  "Scout ({n} left)": "Разведка (осталось: {n})",
  "{n} safe tiles opened · {d} defenders in play": "Открыто плиток: {n} · защитников в игре: {d}",
  "Scout report — a defender is marked!": "Отчет разведки: защитник обнаружен!",
  "Scout failed — no intel": "Разведка не удалась — данных нет",
  "Answer to scout a defender": "Ответь, чтобы найти защитника",
  "Tackled!": "Тебя обыграли!",
  "A defender got you after {n} clean tiles — the pot is gone.": "Защитник поймал тебя, пройдено плиток: {n} — банк потерян.",
  "New run": "Новый забег",
  "{n} clean dribbles at {mult}x.": "Дриблингов: {n} с множителем {mult}x.",
  "Quiz Board": "Квиз-доска",
  "Pick tiles, bank the value — steal when the AI slips": "Выбирай плитки, копи очки — кради их при ошибке ИИ",
  "Nine tiles, three value tiers. Answer to bank the tile and keep control — miss and the AI can steal. Highest bank wins.": "Девять плиток, три уровня ценности. Отвечай верно, чтобы забрать очки. Ошибешься — ИИ может их украсть. Побеждает лидер по очкам.",
  "Start game": "Начать игру",
  "Clubs": "Клубы",
  "Legends": "Легенды",
  "Tournaments": "Турниры",
  "Your board — pick a tile": "Твой ход — выбери плитку",
  "AI is picking a tile…": "ИИ выбирает плитку…",
  "AI plays for {v}": "ИИ играет за {v}",
  "AI banks it": "ИИ забирает очки",
  "AI is wrong — steal it!": "ИИ ошибся — кради очки!",
  "STEAL for {v}!": "УКРАСТЬ за {v}!",
  "For {v}": "За {v}",
  "Final banks — you {a}, AI {b}.": "Итоги — у тебя {a}, у ИИ {b}.",
  "New board": "Новое поле",
  "Last One Standing": "Последний герой",
  "{n} enter, one survives — make every cut": "Участников: {n}, выживет один — пройди все отсевы",
  "Alive": "В игре",
  "Battle royale quiz": "Квиз в стиле королевской битвы",
  "Every round the field is cut — answer right and fast to stay in it. Nine rounds from {n} players down to one.": "Каждый раунд часть игроков выбывает. Отвечай верно и быстро, чтобы остаться. Девять раундов: игроков в начале — {n}, в конце — один.",
  "Kick off": "В бой",
  "Continue": "Продолжить",
  "A legendary goal replays on the coaching board. Name it — the first solve of each goal pays coins and XP.": "Легендарный гол на тактической доске. Угадай его — первая разгадка каждого гола дает монеты и XP.",
  "A legendary goal replays on the coaching board. Watch the moves and name the goal.": "Легендарный гол на тактической доске. Следи за движением и назови автора.",
  "Back tomorrow": "Заходи завтра",
  "All {limit} goals played — come back tomorrow": "Все голы ({limit}) сыграны — возвращайся завтра",
  "{left} of {limit} goals left today": "Осталось голов на сегодня: {left} из {limit}",
  "Daily coins earned — more tomorrow": "Дневной лимит монет исчерпан — ждем завтра",
  "Today: {today}/{cap} coins": "Монеты сегодня: {today}/{cap}",
  "Your collection": "Твоя коллекция",
  "Fastest {cap} survive": "Выживут самые быстрые: {cap}",
  "Field": "Поле",
  "You made the cut!": "Ты в игре!",
  "#{rank} fastest — {cap} players remain.": "№{rank} по скорости — в игре осталось {cap} чел.",
  "Cut!": "Вылет!",
  "Finished #{place} of {n}": "Финиш: {place}-е место из {n}",
  "Round {r} was your last — the field marched on without you.": "Раунд {r} стал последним — турнир продолжился без тебя.",
  "Re-enter": "Войти снова",
  "CHAMPION!": "ЧЕМПИОН!",
  "{n} started. You are the last one standing.": "Участвовало: {n}. Ты — последний выживший.",
  "Defend the title": "Защитить титул",
  "Golden Goal": "Golden Goal",
  "Sudden death — push the ball into their net": "До золотого гола — забей мяч в чужие ворота",
  "Round": "Раунд",
  "Both of you answer the same question — faster and righter pushes the ball. Reach ±{n} and it is a goal. First goal wins.": "Отвечайте на один вопрос — кто быстрее и точнее, тот толкает мяч. Дойди до ±{n}, чтобы забить. Первый гол побеждает.",
  "AI net": "Ворота ИИ",
  "Your attack": "Твоя атака",
  "GOLDEN GOAL!": "ЗОЛОТОЙ ГОЛ!",
  "AI scores": "ИИ забивает",
  "Decided in {n} rounds.": "Число раундов: {n}.",
  "Rematch": "Реванш",
  "vs": "против",
  "Career Race": "Career Race",
  "The transfer trail reveals — buzz before your rival": "Трансферный след ведет к цели — жми кнопку раньше соперника",
  "Clubs appear one by one. Buzz early for 100 points — every extra club cuts the prize. Wrong buzz and you are out of the round. Best of {n}.": "Клубы открываются по одному. Жми сразу для 100 очков — каждый новый клуб снижает награду. Ошибешься — выбываешь из раунда. Максимум раундов: {n}.",
  "Start race": "Начать гонку",
  "Buzz now: {pts} pts": "Жми сейчас: {pts} очк.",
  "Locked out": "Доступ закрыт",
  "BUZZ!": "ЖМИ!",
  "Rival buzzed wrong — they are out!": "Соперник ошибся и выбывает!",
  "Your rival is watching the same trail…": "Соперник видит тот же след…",
  "Whose career is this?": "Чья это карьера?",
  "Wrong — locked out!": "Мимо — доступ закрыт!",
  "⚡ Rival buzzes…": "⚡ Соперник жмет…",
  "+{pts} — yours!": "+{pts} — твои!",
  "Rival takes {pts}": "Соперник берет {pts}",
  "Nobody got it": "Никто не угадал",
  "It was {name}": "Это был {name}",
  "You win the race!": "Ты побеждаешь в гонке!",
  "Rival wins": "Соперник победил",
  "Race again": "Еще раз",
  "Stat Sniper": "Stat Sniper",
  "No options, no help — land your guess on the number": "Без вариантов и подсказок — угадай точное число",
  "Score": "Счет",
  "{n} numeric stats — slide to your best guess. The closer you land, the more you score; a perfect hit pays a bullseye bonus.": "{n} числовых статов — выбери верное значение. Чем точнее, тем больше очков; за прямое попадание — бонус «в яблочко».",
  "Take aim": "Целься",
  "Target {n} / {total}": "Цель {n} / {total}",
  "Lock it in": "Подтвердить",
  "Answer": "Ответ",
  "BULLSEYE! +{pts}": "В ЯБЛОЧКО! +{pts}",
  "+{pts} pts": "+{pts} очк.",
  "You were {diff} off.": "Мимо на {diff}.",
  "Next target": "Следующая цель",
  "Elite sniper!": "Элитный снайпер!",
  "Sharp shooter": "Меткий стрелок",
  "On the range": "На прицеле",
  "Blindfolded": "С закрытыми глазами",
  "{score} points over {n} targets": "Очки: {score}, целей: {n}",
  "Reload": "Перезарядка",
  "Every shot is a 50/50 duel with the keeper. Answer questions to boost the payout — a wrong answer resets the boost.": "Каждый удар — дуэль с вратарем 50/50. Отвечай на вопросы, чтобы увеличить множитель. Ошибка сбросит буст.",
  "Boost {a}/{max} · ×{mult}": "Буст {a}/{max} · ×{mult}",
  "BOOSTED! Payout is now ×{mult}": "БУСТ! Выплата теперь ×{mult}",
  "Wrong — boost resets to ×{mult}": "Ошибка — буст сброшен до ×{mult}",
  "50/50 shot · current payout ×{mult}": "Шанс 50/50 · выплата ×{mult}",
  "Answer · boost to ×{next}": "Ответить · буст до ×{next}",
  "Boosts raise the payout — the shot stays 50/50.": "Бусты растят выплату, но шанс удара остается 50/50.",
  "Boosting…": "Усиление…",
  "Time's up — boost resets to ×{mult}": "Время вышло — буст сброшен до ×{mult}",
  "Left or right — the keeper picks one": "Лево или право — вратарь выберет одну сторону",
  "Pick your corner": "Выбери угол",
  "Next attack risks the whole pot — the boost resets.": "Следующая атака рискует всем банком — буст сбросится.",
  "Run ×{run} → ×{next}": "Серия ×{run} → ×{next}",
  "Run": "Серия",
  "Answering is locked this attack — take the shot.": "В этой атаке нельзя отвечать — бей по воротам.",
  "Sound settings": "Настройки звука",
  "Crowd": "Трибуны",
  "Effects": "Эффекты",
  "Off": "Выкл",
  "More open zones = better odds of keeping the run alive.": "Больше открытых зон = выше шансы продолжить серию.",
  "The goal opens with 2 zones and one hidden keeper. Answer questions to open up to 6 — a wrong answer slams it back to 2.": "В воротах 2 зоны и скрытый вратарь. Отвечай на вопросы, чтобы открыть до 6 зон. Ошибка сбросит их число до 2.",
  "{k} open · {pct}% · ×{mult}": "Открыто: {k} · {pct}% · ×{mult}",
  "Zone opened! {k} of {max} in play": "Зона открыта! В игре {k} из {max}",
  "Pick your angle and shoot · {pot} → {next}": "Выбери угол и бей · {pot} → {next}",
  "Wrong — goal slams back to {n} zones": "Ошибка — зон снова {n}",
  "{k} zones open · 1 keeper hidden · {pct}% goal": "Открыто зон: {k} · 1 вратарь · Гол: {pct}%",
  "Answer · open zone {n}": "Ответить · Открыть зону {n}",
  "Shoot · {pot} → {next}": "Удар · {pot} → {next}",
  "More zones = safer shot, smaller payout — the maths favours knowing.": "Больше зон = безопаснее удар, но меньше выплата. Знания выгодны.",
  "Opening the goal…": "Открываем ворота…",
  "Read the question…": "Читай вопрос…",
  "Time's up — the goal slams back to {n} zones": "Время вышло — число зон сброшено до {n}",
  "Wrong — the goal slams back to {n} zones": "Ошибка — число зон сброшено до {n}",
  "{k} zones open — one hides the keeper": "Открыто зон: {k} — за одной скрыт вратарь",
  "{pct}% goal": "Гол: {pct}%",
  "Next attack risks the whole pot — the goal resets to {n} zones.": "Следующая атака рискует всем банком — ворота сбросятся (зон: {n}).",
  "Guess the Card": "Угадай карту",
  "FIFA Cards": "Карточки FIFA",
  "Spin for a FIFA edition, then name the player from the stats": "Крути издание FIFA и назови игрока по статам",
  "Spinning the edition…": "Выбираем издание…",
  "Locked in!": "Выбрано!",
  "Guess the player from the drawn edition": "Угадай игрока по выпавшему изданию",
  "Card": "Карточка",
  "No clues": "Нет подсказок",
  "{clue} unlocks in": "{clue} откроется через",
  "Final clue — answer now": "Последняя подсказка — отвечай",
  "Name the player…": "Назови игрока…",
  "Named on stats alone": "Угадано только по статам",
  "Guessed with {n} clue(s)": "Угадано с подсказками: {n}",
  "Round complete": "Раунд завершен",
  "of {max} · {n}/{total} named": "из {max} · названо: {n}/{total}",
  "Card {n}/{total}": "Карточка {n}/{total}",
  "Spin for a FIFA edition, then name the player from the card": "Крути издание FIFA и назови игрока по карточке",
  "Give up": "Сдаться",
  "Wrong!": "Неверно!",
  "Medium": "Средне",
  "Very hard": "Очень сложно",
  "Medium/Easy": "Средне/Легко",
  "Pre-FIFA 20": "До FIFA 20",
  "Tap a lock to reveal a clue": "Нажми на замок, чтобы открыть подсказку",
  "Clue revealed": "Подсказка открыта",
  "The answer": "Ответ",
  "{clue} unlocks next": "{clue} откроет следующую",
  "Nice — +{p}": "Круто — +{p}",
  "Daily complete!": "Дневное задание выполнено!",
  "Today's round is done": "Сегодняшний раунд завершен",
  "Coins earned": "Получено монет",
  "Solved": "Решено",
  "New cards at reset": "Новые карты после сброса",
  "Come back tomorrow": "Возвращайся завтра",
  "Reveal clue": "Открыть подсказку",
  "Hidden clue": "Скрытая подсказка",
  "Back to challenges": "К испытаниям",
  "A gold card, stats only — name the player across 10 editions.": "Золотая карта, только статы — назови игрока в 10 изданиях.",
  "Tap a lock to buy that clue": "Нажми на замок, чтобы купить подсказку",
  "Today {n} pts": "Сегодня: {n} очк.",
  "Correct now = {n} pts": "Верный ответ сейчас = {n} очк.",
  "Not {name} · −{n} coins": "Это не {name} · монеты: −{n}",
  "Revealed": "Открыто",
  "Reveal {clue} for {n} coins": "Открыть {clue} (монеты: {n})",
  "Hint budget": "Бюджет подсказок",
  "Hint budget: {n} pts": "Бюджет подсказок: {n} очк.",
  "Hint budget resets every card · separate from your coins": "Бюджет обновляется с каждой карточкой · это не твои монеты",
  "Not {name} · −{n} pts": "Это не {name} · −{n} очк.",
  "Reveal {clue} for {n} pts": "Открыть {clue} за {n} очк.",
  "Buy clues on the card, name the player, keep your points": "Покупай подсказки на карточке, назови игрока и сохрани очки",
  "Hints bought: {n}": "Куплено подсказок: {n}",
  "No hints bought": "Без подсказок",
  "+{n} pts saved by skipping hints": "Сэкономлено без подсказок: +{n} очк.",
  "No points on a surrendered card": "За сданную карточку очков нет",
  "Next card": "Следующая карточка",
  "See results": "Посмотреть результаты",
  "{n} pts": "{n} очк.",
  "Points saved through deduction": "Очки, сэкономленные дедукцией",
  "Across {n} solved cards": "Угадано карточек: {n}",
  "photo": "фото",
  "nation": "страна",
  "position": "ПОЗ",
  "club": "клуб",
  "league": "лига",
  "POS": "ПОЗ",
  "NATION": "СТРАНА",
  "LEAGUE": "ЛИГА",
  "CLUB": "КЛУБ",
  "Dealing…": "Раздача…",
  "Your card": "Твоя карточка",
  "Buy clues on the card, name the player, keep your coins": "Покупай подсказки, назови игрока и сохрани свои монеты",
  "Start": "Старт",
  "Run complete": "Забег окончен",
  "Rival": "Соперник",
};
